import React, { useEffect } from 'react'
import digital2026 from '../../assets/Digital2026ModeloReal.png'
import QRCode from 'react-qr-code'
import domtoimage from 'dom-to-image';
import { useGlobalCarteira } from '../../storage/globalCarteira';
import { escolaridadeAll } from '../../utils';

export default function GlobalPdf2026({ show = false, data = null }) {

    const { dataCarteira } = useGlobalCarteira(state => state)

    var currentData = {
        cpf: dataCarteira?.cpf,
        imagem: dataCarteira?.imagem,
        codigoUso: dataCarteira?.codigoUso,
        nome: dataCarteira?.nome,
        email: dataCarteira?.email,
        rg: dataCarteira?.rg,
        dataNascimento: dataCarteira?.dataNascimento,
        instituicao: dataCarteira?.instituicao,
        curso: dataCarteira?.curso,
        escolaridade: dataCarteira?.escolaridade,
        codId: dataCarteira?.codId,
        validadeCarteirinha: dataCarteira?.validadeCarteirinha
    }

    if (data != null) {
        currentData = {
            cpf: data?.cpf,
            imagem: data?.imagem,
            codigoUso: data?.codigoUso,
            nome: data?.nome,
            email: data?.email,
            rg: data?.rg,
            dataNascimento: data?.dataNascimento,
            instituicao: data?.instituicao,
            curso: data?.curso,
            escolaridade: data?.escolaridade,
            codId: data?.codId,
            validadeCarteirinha: data?.validadeCarteirinha,
        }
    }

    const confDigital = {
        qrcodeTamanho: 85,
        qrcodeTop: '95px',
        qrcodeRight: '23px',
        fontSizeConteudo: '10px'
    }

    var size = '10px'

    function capitalizarComExcecoes(texto) {
        const excecoes = ["de", "do", "da"];

        if(!texto) return ''
        console.log(texto)
        return texto
          .toLowerCase()
          .split(" ")
          .map(palavra => {
            if (excecoes.includes(palavra)) {
              return palavra;
            }
      
            return palavra.charAt(0).toUpperCase() + palavra.slice(1);
          })
          .join(" ");
      }

    function formatarCPF(valor) {
        if (typeof valor !== "string") return valor;
      
        const cpfFormatadoRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
      
        // Já está no formato correto
        if (cpfFormatadoRegex.test(valor)) {
          return valor;
        }
      
        // Remove tudo que não for número
        const apenasNumeros = valor.replace(/\D/g, "");
      
        // Se não tiver 11 dígitos, não converte
        if (apenasNumeros.length !== 11) {
          return valor;
        }
      
        // Converte para o formato xxx.xxx.xxx-xx
        return apenasNumeros.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          "$1.$2.$3-$4"
        );
      } 

    const oculto = show ? { display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' } : { width: '10px', height: '10px', overflow: 'auto', position: 'absolute', top: '0', left: '0' }

    return (
        <div style={oculto}> 
            <div id='node_to_pdf2026' style={{ width: '350px', height: '700px', position: 'relative' }}>
                <img width={350} height={700} src={digital2026} />
                <div style={{ position: 'absolute', top: '138px', right: '33px' }}>
                    {<QRCode
                        bgColor='#00000000'
                        size={120}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={`https://funemg.vercel.app/validar/${currentData?.email}`}
                        viewBox={`0 0 256 256`}
                    />}
                </div>
                {currentData?.imagem !== 0 && <img style={{ position: 'absolute', top: '129px', left: '20px', fontSize: '10px', width: '144px', height: '187px', borderRadius: '17px' }} src={currentData?.imagem} />}
                <div style={{ position: 'absolute', top: '267px', right: '17px', fontSize: '16px', width: '150px', textAlign: 'center', fontWeight: '200' }}>
                <h6 ><b style={{ color: 'black', fontSize: '15px', fontWeight: '500' }}>Cod. uso/CIE</b> </h6>
                  <b style={{ color: 'black' }}>{currentData?.codigoUso}</b>
                   </div>
                <div style={{ position: 'absolute', top: '346px', left: '25px', width: '300px', height: '190px', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}> {capitalizarComExcecoes(currentData?.nome)}</b></h6>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>Ins. Ensino: {capitalizarComExcecoes(currentData?.instituicao)}</b></h6>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>Curso: {capitalizarComExcecoes(currentData?.curso)}</b></h6>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>Nível de Ensino: {currentData?.escolaridade?.toUpperCase()}</b></h6>
                    {/* <h6 style={{ fontSize: '11px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>CPF: {formatarCPF(currentData?.cpf?.toUpperCase())}</b></h6> */}
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>CPF: {formatarCPF(currentData?.cpf)}</b></h6>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>Data de Nasc: {currentData?.dataNascimento}</b> </h6>
                    <h6 style={{ fontSize: '13px', textAlign: 'start', minHeight: '10px', fontWeight: '200' }}><b style={{ color: 'black' }}>Validade: {currentData?.validadeCarteirinha}</b></h6>
                </div>
                
                <a style={{ position: 'absolute', bottom: '67px', left: '81px', fontSize: '10px', height: '37px', width: '192px', }} href={`https://funemg.vercel.app/certificado/${currentData?.email}`}></a>
            </div>
        </div>
    )
}
